import React from "react";
import Image from "next/image";
import webBanner from "../public/images/page_banner/new-sangam-facilities-desk.jpg";
import mobBanner from "../public/images/page_banner/sangam-facilities-mob.jpg";
import { Col, Container, Row, Tab, Table, Tabs } from "react-bootstrap";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Sangamfacilities = ({ data }) => {
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="blue_bg sec-padd">
        <Container>
          <div className="inner_text text-white text-center">
            <p>
              <strong>
                With any of Alcove’s flats at New Kolkata, Serampore, one is
                entitled to a vast selection of modern-day amenities. However,
                the newly-introduced Sangam offers more room for several
                clubhouse facilities, where it holds a capacity of 90 - 100
                people in its AC home theatre while Prayag allows just 50 - 75.
              </strong>
            </p>
          </div>
        </Container>
      </section>
      <section className="sec-padd facility-section">
        <div className="facility-wrapper sangam-facilities">
          <Tabs
            defaultActiveKey="club_house"
            id="gallery"
            className="justify-content-center tab_ver2"
            variant="pills"
          >
            <Tab eventKey="club_house" title="Club House">
              <div className="position-relative">
                <div className="img-wrap image-container">
                  <Image
                    fill
                    src="/images/gallery/club_house.jpg"
                    alt="Club House"
                    className="image"
                  />
                </div>
                <div className="facility-details-wrap">
                  <Row className="justify-content-end">
                    <Col md={7}>
                      <div className="mCSB_container">
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img01.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Swimming Pools with poolside deck.</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img02.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Kids’ Pool</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img03.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Changing Rooms with Shower Area &amp; Locker
                              facility
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img04.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Toilets for Ladies &amp; Gents</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img05.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              A Hall for Multipurpose activities like Karaoke,
                              Dance Classes, Cooking Classes etc
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img06.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Hi-tech Multi Gym with changing rooms &amp;
                              lockers
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img07.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Snacks corner / Dedicated kitchen and Cafeteria,
                              with sitting capacity of 60-70 people
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img08.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              AC Home Theatre with surround sound system,
                              seating capacity of approximately 90 people.
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img09.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              AC Indoor Kids’ &amp; Toddlers’ playing Zone
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img10.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Well-furnished reading room</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/clue_icon/img11.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              AC Indoor Games Arena -
                              <ul>
                                <li>a. – pool table</li>
                                <li>b. - table tennis</li>
                                <li>c. – carrom, chess, dart</li>
                                <li>d. – Squash court</li>
                                <li>e. – badminton court</li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Tab>
            <Tab eventKey="outdoor" title="Outdoor">
              <div className="position-relative">
                <div className="img-wrap image-container">
                  <Image
                    fill
                    src="/images/gallery/outdoor.jpg"
                    alt="outdoor"
                    className="image"
                  />
                </div>
                <div className="facility-details-wrap">
                  <Row className="justify-content-end">
                    <Col md={7}>
                      <div className="mCSB_container">
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img02.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Outdoor meditation &amp; yoga Space</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img03.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Outdoor Amphitheatre for cultural programme,
                              laughing classes etc.
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img05.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Landscaped Waterbody with Fountains &amp;
                              Lightings
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img06.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Landscape garden on podium</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img07.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Outdoor Children’s Play Area with slide &amp;
                              swing
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img08.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Jogging Track / Walkways</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img09.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Cycling Track</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img10.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Pet Park</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/outdoor_icon/img11.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Calisthenics’ workout area</li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Tab>
            <Tab eventKey="utilities" title="Common Utilities & Services*">
              <div className="position-relative">
                <div className="img-wrap image-container">
                  <Image
                    fill
                    src="/images/gallery/common_utilities.jpg"
                    alt="interior"
                    className="image"
                  />
                </div>
                <div className="facility-details-wrap">
                  <Row className="justify-content-end">
                    <Col md={7}>
                      <div className="mCSB_container">
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img02.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Common Toilets for drivers / domestic help</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img03.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              CCTV surveillance and other state-of-the-art
                              security systems
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img04.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Modern equipment’s and measures for Fire-fighting
                              &amp; Fire-safety in compliance with norms
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img05.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              24x7 Power Back up Limited to (1BHK-0.50KVA, 2BHK
                              - 0.75 KVA, 3BHK - 1KVA)
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img06.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>
                              Provision of DTH connection (Centralised System)
                            </li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img07.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Rain Water Harvesting</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img08.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Solar Power Plant</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img09.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Water Filtration / Treatment Plant</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img10.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Sewerage Treatment Plant</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img11.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Garbage dumping point/space</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img12.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Dedicated Visitors’ Car Parking spaces</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img13.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Administration Office.</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img14.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Drivers sitting area</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <span className="amenities-icon">
                            <Image
                              fill
                              alt="icon"
                              src="/images/amenities/services_icon/img06.png"
                              className="mCS_img_loaded image"
                            />
                          </span>
                          <ul className="amenities-list">
                            <li>Requisite arrangement of Intercom/EPBAX.</li>
                          </ul>
                        </div>
                        <div className="amenities-list-box">
                          <ul className="amenities-list">
                            <li>*at extra cost</li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </section>
    </>
  );
};

export default Sangamfacilities;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/sangam-facilitie?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
